"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const epic_react_common_1 = require("epic-react-common");
const epic_react_common_2 = require("epic-react-common");
exports.default = epic_react_common_2.registerLocalizationStore(epic_react_common_1.alt);
//# sourceMappingURL=LocalizationStore.js.map